/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2021 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
import { Group } from 'three';
export class ExtendedGroup extends Group {
    constructor() {
        super();
        this.isExtendedGroup = true;
        this.isMesh = false;
        this.hasBody = false;
        // convex object breaking
        this.fragmentDepth = 0;
        this.breakable = false;
        this.fractureImpulse = 1;
        this.name = `object-${this.id}`;
    }
}
//# sourceMappingURL=extendedGroup.js.map